module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_containert"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fifc-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The stunning shape of the rare, Malcolm Sayer-designed Low Drag E-Type seen from above with the aero design features obvious.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-259fe3d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Fm01.vue
// module id = 57
// module chunks = 0